/** Crew earnings card helpers (pure). */

function manilaParts(iso: string): { day: number; month: string; year: number } {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Manila',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).formatToParts(new Date(iso));
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? '';
  return { day: Number(get('day')), month: get('month'), year: Number(get('year')) };
}

/** "16–31 Oct" for a pay fortnight given its ISO bounds (Asia/Manila). */
export function formatPayPeriodRange(startIso: string, endIso: string): string {
  const a = manilaParts(startIso);
  const b = manilaParts(endIso);
  if (a.month === b.month && a.year === b.year) return `${a.day}–${b.day} ${b.month}`;
  return `${a.day} ${a.month} – ${b.day} ${b.month}`;
}
